import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { debounceTime } from 'rxjs/operators';
import { CommsPreferencesDTO } from '../../model/communication-preferences.dto';

@Component({
  selector: 'hfc-updates-container',
  templateUrl: './updates-container.component.html',
  styleUrls: ['./updates-container.component.scss']
})
export class UpdatesContainerComponent implements OnInit {
  @Input() isEssential: boolean;
  @Input() updatesTitle = '';
  @Input() commsPreferences?: CommsPreferencesDTO;
  @Output() importantUpdatesChanged = new EventEmitter<CommsPreferencesDTO>();
  @Output() optionalUpdatesChanged = new EventEmitter<CommsPreferencesDTO>();
  @Output() showPaperlessGraphic = new EventEmitter<boolean>();

  public isLoading = false;
  public updatesForm: UntypedFormGroup;
  private hasPaperlessEmitted = false;

  constructor(private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    if (!this.commsPreferences) {
      return;
    }

    this.buildForm();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['commsPreferences'] && changes['commsPreferences'].currentValue && !this.updatesForm) {
      this.buildForm();
    }
  }

  importantControl(name: string) {
    return this.updatesForm.get(['importantMarketingUpdates', name]);
  }

  optionalControl(name: string) {
    return this.updatesForm.get(['optionalMarketingUpdates', name]);
  }

  public get isDisabled() {
    return (
      this.importantControl('essentialEmail').status === 'DISABLED' ||
      this.importantControl('essentialPhone').status === 'DISABLED'
    );
  }

  public unsubscribe() {
    this.updatesForm.get('optionalMarketingUpdates').patchValue({
      mortgageMarketUpdateEmail: false,
      nonEssentialEmail: false,
      nonEssentialPhone: false,
      nonEssentialWhatsapp: false,
      nonEssentialPost: false
    });
  }

  private buildForm(): void {
    this.updatesForm = this.fb.group({
      importantMarketingUpdates: this.fb.group({
        essentialEmail: [
          {
            value: true,
            disabled: true
          }
        ],
        essentialPhone: [
          {
            value: true,
            disabled: true
          }
        ],
        essentialWhatsapp: [this.commsPreferences?.essentialWhatsapp ?? false],
        essentialPost: [this.commsPreferences?.essentialPost ?? false],
        preferenceNote: [this.commsPreferences?.preferenceNote]
      }),
      optionalMarketingUpdates: this.fb.group({
        mortgageMarketUpdateEmail: [this.commsPreferences?.mortgageMarketUpdateEmail ?? false],
        nonEssentialEmail: [this.commsPreferences?.nonEssentialEmail ?? false],
        nonEssentialPhone: [this.commsPreferences?.nonEssentialPhone ?? false],
        nonEssentialWhatsapp: [this.commsPreferences?.nonEssentialWhatsapp ?? false],
        nonEssentialPost: [this.commsPreferences?.nonEssentialPost ?? false]
      })
    });

    this.importantUpdatesChanged.emit(this.updatesForm.get('importantMarketingUpdates')?.value);
    this.optionalUpdatesChanged.emit(this.updatesForm.get('optionalMarketingUpdates')?.value);

    this.updatesForm.valueChanges.pipe(debounceTime(200)).subscribe((value) => {
      this.importantUpdatesChanged.emit(value.importantMarketingUpdates);
      this.optionalUpdatesChanged.emit(value.optionalMarketingUpdates);

      if (
        (this.importantControl('essentialPost').dirty || this.optionalControl('nonEssentialPost').dirty) &&
        !this.hasPaperlessEmitted
      ) {
        this.showPaperlessGraphic.emit(true);
        this.hasPaperlessEmitted = true;
      }
    });
  }
}
